import React, { useState } from "react";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";
import MegaMenuLanding from "../../header/mega-menu/MegaMenuLanding";

const HeaderLandingWebsiteBuilder = () => {
  // For Mobile  menu
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 90) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <>
      {/* =============================================
				Theme Main Menu
			==============================================  */}
      <div
        className={
          navbar
            ? "theme-main-menu sticky-menu theme-menu-seven bg-none fixed"
            : "theme-main-menu sticky-menu theme-menu-seven bg-none"
        }
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="logo order-lg-1">
            <Link to="/">
              <img src="images/logo/deski_09.svg" alt="brand" />
            </Link>
          </div>
          {/* End logo */}

          <div className="right-widget order-lg-3">
            <ul className="d-flex align-items-center">
              <li className="ltc-login">
                <a
                  href="https://console.idcheck.com.vn/"
                  className="signIn-action d-flex align-items-center"
                >
                  <img src="images/icon/120.svg" alt="icon" />
                  <span>Đăng nhập</span>
                </a>
              </li>
              {/* End login */}
              <li>
                <a
                  href="https://console.idcheck.com.vn/"
                  className="theme-btn-twelve d-none d-lg-block"
                >
                  Trải nghiệm
                </a>
              </li>
            </ul>
          </div>
          {/* End right-widget */}

          <nav
            id="mega-menu-holder"
            className="navbar navbar-expand-lg ps-xl-5 ms-xl-5 order-lg-2"
          >
            <div className="container nav-container">
              <div className="mob-header">
                <button className="toggler-menu" onClick={handleClick}>
                  <div className={click ? "active" : ""}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </button>
              </div>
              {/* End Header */}

              <div
                className="navbar-collapse collapse landing-menu-onepage"
                id="navbarSupportedContent"
              >
                <div className="d-lg-flex justify-content-between align-items-center">
                  <Scrollspy
                    className="navbar-nav  main-side-nav font-gordita"
                    items={["home", "feature", "p-tour", "feedback"]}
                    currentClassName="active"
                    offset={-90}
                  >
                    <li className="hide1180 nav-item dropdown position-static">
                      <a
                        className="nav-link"
                        href="#home"
                      >
                        Trang chủ
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#feature" className="nav-link">
                        Tính năng
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#p-tour" className="nav-link">
                        Trải nghiệm
                      </a>
                    </li>

                    <li className="nav-item">
                      <a href="/kien-thuc" className="nav-link">
                        Chia sẻ kiến thức
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/about-cs" className="nav-link">
                        Về chúng tôi
                      </a>
                    </li>
                  </Scrollspy>
                </div>
              </div>
            </div>
          </nav>
          {/* End Navbar */}
        </div>
      </div>
      {/* /.theme-main-menu */}

      {/* Mobile Menu Start */}
      <div className={click ? "mobile-menu  menu-open" : "mobile-menu"}>
        <div className="logo order-md-1">
          <Link to="/doc-landing">
            <img src="images/logo/deski_06.svg" alt="brand" />
          </Link>
          <div className="fix-icon text-dark" onClick={handleClick}>
            <img src="images/icon/close.svg" alt="icon" />
          </div>
          {/* Mobile Menu close icon */}
        </div>

        <Scrollspy
          className="navbar-nav  main-side-nav font-gordita"
          items={["home", "feature", "p-tour", "feedback"]}
          currentClassName="active"
          offset={-90}
        >
          <li className="nav-item">
            <a href="/" className="nav-link" onClick={handleClick}>
              Trang chủ
            </a>
          </li>
          <li className="nav-item">
            <a href="/tinh-nang" className="nav-link" onClick={handleClick}>
              Tính năng
            </a>
          </li>
          <li className="nav-item">
            <a href="/bang-gia" className="nav-link" onClick={handleClick}>
              Báo giá
            </a>
          </li>

          <li className="nav-item">
            <a href="/kien-thuc" className="nav-link" onClick={handleClick}>
              Chia sẻ kiến thức
            </a>
          </li>
          <li className="nav-item">
            <a href="https://console.idcheck.com.vn" className="nav-link" onClick={handleClick}>
              Đăng nhập
            </a>
          </li>
        </Scrollspy>
      </div>
      {/* Mobile Menu End */}
    </>
  );
};

export default HeaderLandingWebsiteBuilder;
